import { z } from "zod";

/**
 * These filters are used to filter the sites in the clustered viewport map
 * layer.
 */
export const SitesFiltersSchema = z.object({
  workspaces: z.array(z.string()).length(1),
  stages: z.array(z.string()).optional(),
  searchText: z.string().optional(),
  assignees: z.array(z.string()).optional(),
  siteLabels: z.array(z.string()).optional(),
  localAuthorities: z.array(z.string()).optional(),
  showHiddenSites: z.boolean(),
  showSharedSites: z.boolean(),
});

export type SitesFilters = z.infer<typeof SitesFiltersSchema>;
